

var radarManager = {};
var pageManager = null;

function handlePageManager( pmObj ) {
  var obj = readPagModJSONObject( pmObj.PagModJSON);

  obj.frame = $("ad_content");
  obj.printCommand = "radarprint";
  obj.groupPagesBy = SCS_PM.GROUP_TYPE_SECTION;
  obj.pageNumType = SCS_PM.NUM_TYPE_ABSOLUTE;
  obj.id = "radar";
  obj.pagesPerRow = 4;
  obj.pagesPerRowCallback = function() { /*repositionSidebar()*/ };

  if ( isUndefinedOrNull( pageManager ) ) {
    pageManager = new PageManager( obj );
    pageManager.addMenuIcon("A_DASH","Absolute/Relative Page Numbering", switchPageNumbering);
    pageManager.addMenuIcon("TREEPICTURE","Show / Hide Ad Images", toggleAdImages);
    pageManager.addMenuIcon("ITEMDETAILS","Show / Hide Element Details", toggleDetailsBar);
    pageManager.addMenuIcon("ZONESICON","Show / Hide Zones", toggleZones);
    pageManager.addMenuIcon("REFRESH","Refresh Edition", radarSearch);
    pageManager.addMenuIcon("REFRESH","Refresh Statuses", refreshPageManagerAds);
    pageManager.addMenuIcon("REDDOT","Turn Off Automatic Refresh", toggleAutoRefresh);

    if ( strip( radarManager.PAGETYPE ) !== "" ) {
      pageManager.addPrefItem( "pt" + radarManager.PAGETYPE,
                               "By Page Type", 1 );
    } 

    if ( strip( radarManager.PUBEDID ) !== "" ) {
      pageManager.addPrefItem( "pub" + radarManager.PUBEDID,
                               "By Publication", 2 );
    }
  }
  else {
    pageManager.init( obj );
  }

  openProgressBar();
  pageManager.draw().addBoth( closeProgressBar );
}

function radarSearch() {
  var myCallback = function( res ) {
    getJSON( "eabjson", handlePageManager );
    sT_radar.loadFromURL2( "spice.pl?command=eabtable" );
  };

  getJSON( "eabsearch", myCallback, { "filepath": $( "filepath" ).value } );
}

function switchPageNumbering()
{
  pageManager.pageNumType = (pageManager.pageNumType === SCS_PM.NUM_TYPE_ABSOLUTE) ?
                            SCS_PM.NUM_TYPE_SECTION :
                            SCS_PM.NUM_TYPE_ABSOLUTE;
  pageManager.draw();
}

function toggleZones()
{
  pageManager.zoneType = (pageManager.zoneType === SCS_PM.ZONE_TYPE_COMMON) ?
                          SCS_PM.ZONE_TYPE_ALL :
                          SCS_PM.ZONE_TYPE_COMMON;
  pageManager.draw();
}

function toggleAdImages()
{
  pageManager.showImages = !pageManager.showImages;
  pageManager.draw();
}

var elemDetailFields = 
{
    "adnumber" : "",
  "description" : "",
  "width" : "",
  "height" : "",
  "page" : "",
  "advertiser" : "",
  "account" : "",
  "adtype" : "",
  "salespersonname" : "",
  "operator" : "",
  "station" : "",
  "loggedat" : "",
  "size" : "",

  "-" : "" // Needed to avoid the trailing comma
};


function forEachElemDetailField(func)
{
  for(var i in elemDetailFields)
  {
    if(i !== "-")
    {
      func(i);
    }
  }
}

/*
  Set the values in the Element Details table to match the 
  properties in obj.  If obj is not specified, set them all 
  to blank.
*/
function setAdDetails( obj )
{
  forEachElemDetailField(function(i)
  {
    var elem = $("item_" + i);
    if ( !isUndefinedOrNull( elem ) ) {
      if ( isUndefinedOrNull( obj ) ) {
        replaceChildNodes( elem, "" );
      }
      else {
        var value = obj[i];

        if ( i == "loggedat" && value != "n/a" && value != "" ) {
          value = unformattedTimestampToMediumDateTime( value );
        }

        if ( i == "adnumber" && obj.adtype == "Ad" &&
             obj.statusdesc != "Unknown" ) {
          var link = constructURL( "adinfo", { "orderid": value },
                                   menuManager.getLocCGI_AI() );
          replaceChildNodes( elem, A( { 'href': link, 'target': '_blank'},
                                      value ) );
        }
        else {
          replaceChildNodes( elem, value );
        }
      }
    }
  });
}

function navAdInfo( orderId )
{
  var row = sT_radar.getRow( orderId );
  if ( row.ADTYPE == "Ad" && row.STATUSDESC != "Unknown" ) {
    openURL( "adinfo", [ "orderid" ], [ orderId ], menuManager.getLocCGI_AI() );
  }
}

function repositionSidebar()
{
  // Get sidebar dimension and position information.
  var sideBar = $( "sidebar" );
  var sideBarDimensions = getElementDimensions( sideBar );
  var heightOfSideBar = Math.floor( sideBarDimensions.h );

  // Hide the sidebar before moving, it looks awkward moving while visible.
  sideBar.display = "none";

    // Get necessary screen information.
  var windowScroll = getViewportPosition();
  var topOfScreen = Math.floor( windowScroll.y );

  // Get radar table dimension and position information.
  var radarTable = $( "radar_table" );
  var radarTableDimensions = getElementDimensions( radarTable );
  var radarTablePosition = getElementPosition( radarTable );
  var heightOfTable = Math.floor( radarTableDimensions.h );
  var topOfTable = Math.floor( radarTablePosition.y );

  // Perform any other necessary calculations.
  var offsetOfSideBar = topOfScreen - topOfTable;

  if ( ( offsetOfSideBar < 30 ) || ( heightOfSideBar >= heightOfTable ) ) {
    // Perform normally, the top of the radar table is on-screen.
    sideBar.style.position = "";
    sideBar.style.top = "";
    sideBar.style.borderTop = "";
  } else if ( ( heightOfSideBar + offsetOfSideBar ) > heightOfTable ) {
    // Move the element details down, but not past the bottom of the table.
    offsetOfSideBar = heightOfTable - heightOfSideBar - 2;
    sideBar.style.position = "relative";
    sideBar.style.top = offsetOfSideBar + "px";
    sideBar.style.borderTop = "2px solid black";
  } else {
    // Move the element details down, on-screen.
    sideBar.style.position = "relative";
    sideBar.style.top = offsetOfSideBar + "px";
    sideBar.style.borderTop = "2px solid black";
  }

  // Show the sidebar now that the move is complete.
  sideBar.display = "";  
}

/**
 * Show (or hide) the details for the selected ad.
 *
 * DR - I don't think we need to make an AJAX request here.  All of
 *      the information is already available.
 */
function showAdDetails(e,select)
{
  var imgbar = $('imagebar');

  if ( !select ) {
    setAdDetails( null );
    replaceChildNodes( imgbar );
    return true;
  }

  var box = pageManager.getObject(e.src());

  // Add the element image below the details (if it has one)
  replaceChildNodes(imgbar);
  var src = box.manager.elements[box.elementid].imagesrc;
  if ( !isUndefinedOrNull( src ) && strip( src ) !== "" ) { 
    var img = IMG( {'src': src, 'alt': 'Ad Image' } );
    setStyle( img, { "width": ( imgbar.offsetWidth - 50 ) + "px",
                     "height": "auto" } );
    addElementClass( imgbar, "scs_center" );
    var adId = box.manager.elements[box.elementid].desctext1;
    var pdfLink = constructURL( "viewadimage",
                                { "viewtype": "pdf",
                                  "orderid": adId },
                                menuManager.getLocCGI_AI(), adId + ".pdf" );

    appendChildNodes( imgbar, HR(), BR(), A({'href':pdfLink, 'target':'_blank'}, img), BR() ); 
  }

  var myCallback = function( res )
  {
    obj = res.adInfo;
    setAdDetails( res.adInfo[0] );
    //repositionSidebar();
  };
  
  return getJSON("radaradinfo", myCallback, { "boxnum": box.boxnum } );
}

function toggleDetailsBar()
{ 
  var sb = $("sidebar");
  if(isUndefinedOrNull(sb)) { return false; }

  if(hasElementClass(sb, "scs_hidden"))
  {
    removeElementClass(sb, "scs_hidden");
    setStyle(sb.parentNode, {'width':'300px'});
  }
  else
  {
    setStyle(sb.parentNode, {'width':'0px'});
    addElementClass(sb, "scs_hidden");
  }
  pageManager.draw();
  return true;
}

/*
  Refresh the table at the bottom and update the colors of the ads
  but do not re-launch a pagrManager.dra() function because it can 
  take too long.
*/
function refreshPageManagerAds() {
  var myCallback = function( obj ) {
    // Update our ads on the pages with new statuses.
    var needTableRefresh = ( !isUndefinedOrNull( obj.Status ) &&
                             obj.Status.length > 0 )

    forEach( obj.Status,
             function( status ) {
               var boxNum = status.boxnum;
               var boxColor = status.boxcolor;
               var fontColor = status.fontcolor;
               var imagePath = status.imagepath;

               try {
                 // Set the properties in the elements[] array so next time we 
                 // draw from the pageManager, we get the right colors
                 var boxObj = pageManager.getBoxObject( boxNum );
                 var boxElem = pageManager.getBoxElement( boxNum );
                 if ( boxObj ) {
                   var elem = pageManager.elements[boxObj.elementid];
                   elem.cssboxcolor = boxColor;
                   elem.cssfontcolor = fontColor;

                   if ( boxElem ) {
                     elem.showimage = ( imagePath != "" );
                   }
                   elem.imagesrc = imagePath;
                   var newBoxElem = boxObj.getBoxNode();
                   boxElem = swapDOM( boxElem, newBoxElem );
                 }

                 if ( boxElem ) {
                   setStyle( boxElem,
                             { 'background-color' : boxColor,
                               'color' : fontColor } );
                 }
               }
               /* Silently ignore exceptions, the table is already up to date, 
                  and this will be in any rare case we cannot find the DIV (not 
                  on the page maybe) or if we get back bad XML */
               catch ( ex ) {
                 log( ex );
               }
             } );

    if ( needTableRefresh ) {
      sT_radar.refreshList();
    }
  }

  if ( ( !sT_radar.tSuspendAutoRefresh ) && ( !pageManager._draw_lock ) ) {
    // Launch a loadFromURL() to just update the table
    getJSON( "checkstatuses", myCallback );
  }
}

var doAutoRefresh = true;
var callbackAdded = false;

function getAutoRefreshCallback() {
  if( doAutoRefresh ) {
    return function(msg){
      refreshPageManagerAds();
      return true;
    }
  }
  else {
    return function(msg){
      return true;
    }
  }
}

function toggleAutoRefresh() {
  if ( doAutoRefresh ) {
    doAutoRefresh = false;
    pageManager.menuIcons.pop();
    pageManager.addMenuIcon("GREENDOT","Turn On Automatic Refresh", toggleAutoRefresh);
    pageManager.redrawActionsMenu();
  } else {
    doAutoRefresh = true;
    pageManager.menuIcons.pop();
    pageManager.addMenuIcon("REDDOT","Turn Off Automatic Refresh", toggleAutoRefresh);        
    pageManager.redrawActionsMenu();    
  }
}
